
//  this is React Multi Date Picker 4.5.2 LibraryRegular. To be able to customize the stylying 
//  I added the code to the utils. 
// https://shahabyazdi.github.io/react-multi-date-picker/types/#icon


import { useEffect, useRef } from "react";
import getLocaleName from "./reports";
import { IconCalendarEvent } from "@tabler/icons-react";

export default function InputIcon({
  value = "",
  className = "rmdp-input",
  separator,
  openCalendar,
  locale,
  iconStyle = {},
  ...otherProps
}) {
  const ref = useRef();

  useEffect(() => {
    let input = ref.current,
      icon = input?.parentNode?.querySelector?.(".rmdp-input-icon"),
      height = input?.clientHeight - 5 + "px";

    if (icon) {
      icon.style.height = height;
      icon.style.width = height;
    }
  });

  return (
    <div style={{ position: "relative" }}>
      <input
        ref={ref}
        type="text"
        className={className}
        value={value}
        autoComplete="off"
        style={{ fontSize: "14px" }} 
        {...otherProps}
      />
      <IconCalendarEvent
        height={20}
        width={20}
        stroke={1.5}
        style={{
          position: "absolute",
          [["fa", "ar"].includes(getLocaleName(locale)) ? "left" : "right"]:
            "15px",
          top: "50%",
          transform: "translateY(-50%)",
          backgroundColor: "inherit",
          cursor: "pointer",
          height: "25px",
          width: "25px",
          color: "grey",
          ...iconStyle,
        }}
        onClick={openCalendar}
      />
    </div>
  );
}
